import React from "react";
import { Chip } from "@mui/material";
import type { PaymentStatus } from "../../api/bookings";

type ChipColor =
  | "default"
  | "primary"
  | "secondary"
  | "error"
  | "info"
  | "success"
  | "warning";

const STATUS_CONFIG: Record<
  PaymentStatus,
  { label: string; color: ChipColor }
> = {
  checkout_created: { label: "Checkout created", color: "info" },
  paid:             { label: "Paid",              color: "success" },
  partially_refunded: { label: "Partially refunded", color: "warning" },
  refunded:         { label: "Refunded",          color: "default" },
  expired:          { label: "Expired",           color: "default" },
  failed:           { label: "Failed",            color: "error" },
  disputed:         { label: "Disputed",          color: "error" },
  anomaly_paid_after_cancellation: {
    label: "Anomaly",
    color: "warning",
  },
};

interface PaymentStatusBadgeProps {
  status: PaymentStatus | null;
}

export const PaymentStatusBadge: React.FC<PaymentStatusBadgeProps> = ({
  status,
}) => {
  if (status === null) return null;

  const config = STATUS_CONFIG[status];
  if (!config) return null;

  return (
    <Chip
      role="img"
      aria-label={`Payment status: ${config.label}`}
      label={config.label}
      color={config.color}
      size="small"
    />
  );
};
